export const inputCls = "w-full rounded-xl border border-stone-300 px-3 py-2 text-sm focus:border-ink focus:outline-none";
export const labelCls = "mb-1 block text-xs font-semibold text-stone2";

export const CTAS = [
    ["SIGN_UP", "Sign Up"], ["LEARN_MORE", "Learn More"], ["GET_QUOTE", "Get Quote"],
    ["APPLY_NOW", "Apply Now"], ["SUBSCRIBE", "Subscribe"], ["DOWNLOAD", "Download"],
    ["BOOK_TRAVEL", "Book Now"], ["CONTACT_US", "Contact Us"],
];

export const OBJECTIVES = [
    ["OUTCOME_LEADS", "Lead Generation", "Collect leads with a native Meta instant form."],
];

export const STATUS_META = {
    draft: ["Draft", "bg-stone-100 text-stone-600"],
    paused: ["Paused", "bg-amber-50 text-amber-700"],
    active: ["Active", "bg-emerald-50 text-emerald-700"],
    completed: ["Completed", "bg-sky-50 text-sky-700"],
};

export function StatusPill({ status }) {
    const [txt, cls] = STATUS_META[status] || STATUS_META.draft;
    return <span className={`rounded-full px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wide ${cls}`}>{txt}</span>;
}

export const fmtMoney = (v, sym = "₹") => (v === null || v === undefined) ? "—" : `${sym}${Number(v).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
export const fmtNum = (v) => (v === null || v === undefined) ? "—" : Number(v).toLocaleString();
export const fmtDay = (s) => { if (!s) return "—"; try { return new Date(s).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }); } catch { return s; } };

export const blankCampaign = {
    name: "", platform: "meta", objective: "OUTCOME_LEADS", ad_account_id: "",
    countries: "IN", age_min: 18, age_max: 65, genders: [],
    budget_type: "daily", daily_budget: 500, lifetime_budget: 0, start_date: "", end_date: "",
    headline: "", primary_text: "", description: "", cta: "SIGN_UP", link: "", image_url: "", privacy_url: "",
    form_mode: "existing", form_id: "", form_name: "", questions: null,
    destination: "salesforce", field_mapping: {},
};
